import { jsPDF as JSPDF } from 'jspdf';
import 'jspdf-autotable';
import moment from 'moment';
import { msToHMS } from '../../helpers';

const formatBreaks = (breaks) => {
  if (!breaks || breaks.length === 0) return '-';
  return breaks
    .map(
      (b) =>
        `${b.type !== null ? b.type.name : 'Other'}${
          b.type?.shortCode ? ` (${b.type.shortCode})` : ''
        }: ${moment(b.startTime).format('h:mm:ss A')} - ${moment(
          b.endTime
        ).format('h:mm:ss A')}`
    )
    .join('\n');
};

const WorksessionRequestsPDF = (requests, fromDate, toDate) => {
  const doc = new JSPDF('l', 'pt', 'a3');
  const totalPagesExp = '{total_pages_count_string}';
  const pageWidth =
    doc.internal.pageSize.width || doc.internal.pageSize.getWidth();

  doc.setFontSize(10);
  doc.text(
    `Period: ${moment(fromDate).format('MMM DD, YYYY')} - ${moment(
      toDate
    ).format('MMM DD, YYYY')}`,
    40,
    60,
    'left'
  );

  const tableRows = requests.map((req) => [
    `${req.user.firstName} ${req.user.lastName || ''}`,
    req.newProject ? req.newProject.title : req.oldProject.title,
    `${msToHMS(req.oldWorkSessionSeconds * 1000)}\nIn: ${moment(
      req.oldCheckInDate
    ).format('MMM Do, YYYY h:mm:ss A')}\nOut: ${moment(
      req.oldCheckOutDate
    ).format('MMM Do, YYYY h:mm:ss A')}`,
    `${msToHMS(req.newWorkSessionSeconds * 1000)}\nIn: ${moment(
      req.newCheckInDate
    ).format('MMM Do, YYYY h:mm:ss A')}\nOut: ${moment(
      req.newCheckOutDate
    ).format('MMM Do, YYYY h:mm:ss A')}`,
    formatBreaks(req.oldBreak),
    formatBreaks(req.newBreak),
    moment(req.requestedDate).format('MMM Do, YYYY h:mm A'),
    req.reason || '-',
    req.status ? req.status.charAt(0).toUpperCase() + req.status.slice(1) : '-',
  ]);

  const tableColumn = [
    'Team Member',
    'Project',
    'Original Worksession',
    'Updated Worksession',
    'Old Breaks',
    'Updated Breaks',
    'Requested Date',
    'Reason',
    'Status',
  ];

  doc.autoTable({
    head: [tableColumn],
    body: tableRows,
    startY: 75,
    theme: 'grid',
    styles: { cellPadding: 6, fontSize: 8, overflow: 'linebreak' },
    headStyles: {
      fillColor: [237, 242, 249],
      textColor: [40, 62, 89],
      halign: 'center',
      fontSize: 8,
    },
    columnStyles: {
      0: { halign: 'left' },
      1: { halign: 'left' },
      2: { halign: 'left' },
      3: { halign: 'left' },
      4: { halign: 'left' },
      5: { halign: 'left' },
      6: { halign: 'center' },
      7: { halign: 'left' },
      8: { halign: 'center' },
    },
    tableLineColor: [237, 242, 249],
    tableLineWidth: 1,
    showFoot: 'lastPage',
    didDrawPage() {
      doc.setFontSize(14);
      doc.setTextColor(40);
      doc.text('Worksession Edit Requests', pageWidth / 2, 23, 'center');
      doc.setFontSize(10);
      let str = `Page ${doc.internal.getNumberOfPages()}`;
      if (typeof doc.putTotalPages === 'function') {
        str = `${str} of ${totalPagesExp}`;
      }
      const { pageSize } = doc.internal;
      const pageHeight = pageSize.height
        ? pageSize.height
        : pageSize.getHeight();
      doc.text(str, pageWidth - 40, pageHeight - 22, { align: 'right' });
    },
  });

  if (typeof doc.putTotalPages === 'function') {
    doc.putTotalPages(totalPagesExp);
  }

  doc.save('worksession_edit_requests.pdf');
};

export default WorksessionRequestsPDF;
